// extracted by mini-css-extract-plugin
module.exports = {"sixDigitCode":"input-code_sixDigitCode__2IErs","inputBackground":"input-code_inputBackground__2cu63","inFocus":"input-code_inFocus__3Ngzb","invalid":"input-code_invalid__tg_QX"};